import { AgentButton, useToasts } from 'global-components-library';
import React from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { RECORD_STATE } from '../../../../constants';
import { useEffect, useState } from 'react';
import { actionPreviewRecord } from '../../../../redux/actions/A_messages_to_SM';
import { incrementDiscardedRegisters, removeRecord } from '../../../../redux/actions/A_preview';
import { Singleton } from '../../../../js/Singleton';
import StopWatchSimultaneousPreview from '../../../Header/StopWatch/StopWatchSimultaneousPreview';
import { timerActions } from '../../../Header/StopWatch/StopWatchSimultaneousPreview';
import { useRef } from 'react';
import { Logger } from '../../../../js/helpers/Logger';

const language = new Singleton();
const TimerCardPreview = ({  fReplacementJob, cardDesignOnTimeOver, record, labelTimer}) => {
    const { callKey,  isTimeAscending, camId, previewTime, callOutId, initPreviewTime, status, dialogTime, dispositionData:{alreadyRated},calloutMaxTime, remainingTime } = record;
    const [secsDialog, setSecsDialog ] = useState(0)
    const { addToast } = useToasts();
    const { records, countRecords,isSomeRecInDialog,countRecordsDialing } = useSelector(state => state.preview); 
    const [timerAction, setTimerAction]=useState((countRecordsDialing > 0 || isSomeRecInDialog)? timerActions.stop : timerActions.start);
    const prevStatus = useRef(status);

    const dispatch = useDispatch();

    useEffect(() => {
        //stop timer because is other record in dialog
        if(status === RECORD_STATE.DEFAULT && dialogTime === undefined && !alreadyRated)
        {
            isSomeRecInDialog ? setTimerAction(timerActions.stop) : setTimerAction(timerActions.start);
        } 
        //stop timer because maximum numbers of simultaneous records was reached
        if((status === RECORD_STATE.DEFAULT && dialogTime === undefined  && !alreadyRated && !isSomeRecInDialog ))
        {
            countRecordsDialing > 0 ? setTimerAction(timerActions.stop) : setTimerAction(timerActions.start)
        } 
      }, [isSomeRecInDialog, countRecordsDialing ]);
        
    useEffect(() => {
        switch (status) {
            case RECORD_STATE.DIALING:
                if(calloutMaxTime > 0)
                {
                    setSecsDialog(calloutMaxTime)
                    setTimerAction(timerActions.startByDialing)
                }
                
                break;

            case RECORD_STATE.DIALOG:
                if(dialogTime > 0){
                    setTimerAction(timerActions.stop)
                }else{
                    setTimerAction(timerActions.restartFromZero)
                }
                break;

            case RECORD_STATE.HOLD:
                setTimerAction(timerActions.restartFromZero)
                break; 

            case RECORD_STATE.ALERT:
                if(prevStatus.current === RECORD_STATE.DIALING){
                    setTimerAction(timerActions.stop)
                }else{

                    setTimerAction(timerActions.stopInZero)
                }
                break;  

            case RECORD_STATE.DEFAULT:
                currentStatusDefaultActions()
                break;

            case RECORD_STATE.WRAPUP:
                if(dialogTime > 0){
                    setSecsDialog(Math.round(dialogTime))
                    setTimerAction(timerActions.restartFromDialogAndStop)
                }
                break;
            case RECORD_STATE.WAITING_WRAPUP:
                setTimerAction(timerActions.restartFromDialogAndStop);
                break
            case RECORD_STATE.ABANDONED:
                if(dialogTime > 0){
                    setSecsDialog(Math.round(dialogTime))
                    setTimerAction(timerActions.restartFromDialogAndStop)
                }
            default:
                break;
        }
        prevStatus.current = status;
    }, [status, dialogTime, calloutMaxTime])

    const currentStatusDefaultActions = () =>{

        const previousStatusValidate = [ RECORD_STATE.ALERT, RECORD_STATE.WRAPUP, RECORD_STATE.DIALOG].includes(prevStatus.current)

        const stopInRemainingTime = [RECORD_STATE.DIALING].includes(prevStatus.current)
        
        const stopAfterDefault = [RECORD_STATE.DEFAULT].includes(prevStatus.current)

        if(stopAfterDefault && isSomeRecInDialog   ){
            setTimerAction(timerActions.stop)
        }
        else if(previousStatusValidate ){
            setTimerAction(timerActions.restartFromInitialSecAndStart)

        }else if(stopInRemainingTime){

            setSecsDialog(Math.round(remainingTime))
            if(isSomeRecInDialog || countRecordsDialing > 0){
                setTimerAction(timerActions.restartFromDialogAndStop)
            }else{
                setTimerAction(timerActions.restartFromDialogAndStart)
            }

        }
    }

 


    const onTimeOver = () =>{
        if(status === RECORD_STATE.DEFAULT)
        { 
            Logger.Info("[TimeCardPreview][onTimeOver] => ", JSON.stringify({callKey, status, fReplacementJob, record }));
            cardDesignOnTimeOver();
            timeIsOver(language.getText('GUIAlertMessagesimultaneousViewTimeExpired').replace('[N]',`[${callKey}]`));
            setTimeout(() => { 
                dispatch(actionPreviewRecord({process:2, camId:camId, callOutId:callOutId, previewTime:initPreviewTime, callId:0, fMultipleJob: records.length === 1 ? 0 : 1, fReplacementJob: fReplacementJob})) 
            }, 100);
            setTimeout(() => {
                dispatch(incrementDiscardedRegisters())
            },100);   
            setTimeout(() => {
                dispatch(removeRecord(callOutId))
            }, 100);
        }
    };
    
    const timeIsOver = message => {
        addToast(message, {
            group: 'icon', 
            position: 'topRight',
            icon: 'warning', 
            color: 'yellow', 
            btnComponent: <AgentButton type='tertiary'>{language.getText("GUIAlertMessageclose")}</AgentButton>,
            timeout: 5000, 
        });
    };

    return (
        <div className='cpr-timerContainer'>
            <div className={`cpr-labelTime ${status}`}>{labelTimer}</div>
            <div className="cpr-timerContainer">
                <p className={`cpr-timeCallBold ${status}`}>
                    <StopWatchSimultaneousPreview
                        onTimeOver={onTimeOver}
                        secondsInitial={remainingTime>0 ? remainingTime : previewTime}
                        secondsDialog={secsDialog}
                        isTimeAscending={(status === RECORD_STATE.DIALOG || status === RECORD_STATE.HOLD) ? true : (status === RECORD_STATE.DIALING ? false : isTimeAscending)}
                        timerAction={timerAction}
                        status={status}
                        id={callKey}
                    />
                </p>
            </div>
        </div>  
    )
}

export default TimerCardPreview


// WEBPACK FOOTER //
// ./src/components/workSpace/SimultaneosRecsPreview/CardPreviewRecord/TimerCardPreview.jsx